const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGt(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82AFFF"
    },
    d: "M188.953,374.155H35.87c-4.661,0-8.44-3.779-8.44-8.44V65.118c0-4.661,3.779-8.44,8.44-8.44h153.083 L188.953,374.155L188.953,374.155z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 188.95,
    y: 56.677,
    style: {
      fill: "#F5F5F5"
    },
    width: 161.52,
    height: 317.48
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82AFFF"
    },
    d: "M503.56,374.155H350.477V56.677H503.56c4.661,0,8.44,3.779,8.44,8.44v300.597 C512,370.376,508.222,374.155,503.56,374.155z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFC855"
    },
    points: "267.607,173.878 262.816,176.273 267.224,178.094 "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M269.715,262.408c-26.627,0-48.29-21.663-48.29-48.29c0-16.541,8.326-31.75,22.271-40.686 l1.24,1.936c-13.281,8.511-21.211,22.997-21.211,38.75c0,25.359,20.632,45.99,45.99,45.99V262.408z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M242.078,265.422c1.84,0.375,4.678-0.11,7.594-1.469s5.113-3.22,6.009-4.87 c-1.84-0.375-4.678,0.111-7.594,1.469C245.172,261.911,242.975,263.772,242.078,265.422z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M255.681,259.083c0.375-1.84-0.111-4.678-1.469-7.594c-1.359-2.916-3.22-5.113-4.87-6.009 c-0.375,1.84,0.111,4.678,1.469,7.594C252.17,255.99,254.031,258.188,255.681,259.083z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M232.458,259.516c1.765,0.64,4.644,0.578,7.727-0.338c3.084-0.916,5.53-2.434,6.659-3.934 c-1.765-0.64-4.644-0.578-7.727,0.338C236.033,256.497,233.586,258.016,232.458,259.516z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M246.845,255.244c0.64-1.765,0.578-4.644-0.338-7.727c-0.916-3.084-2.434-5.53-3.934-6.659 c-0.64,1.765-0.578,4.644,0.338,7.727C243.825,251.669,245.344,254.115,246.845,255.244z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M223.559,251.464c1.62,0.947,4.465,1.402,7.663,1.056c3.198-0.347,5.877-1.401,7.257-2.674 c-1.62-0.947-4.465-1.402-7.662-1.056C227.618,249.137,224.939,250.191,223.559,251.464z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M238.478,249.846c0.947-1.62,1.402-4.465,1.056-7.662c-0.347-3.198-1.401-5.877-2.674-7.257 c-0.947,1.62-1.402,4.465-1.056,7.662C236.151,245.785,237.205,248.465,238.478,249.846z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M216.202,240.344c1.427,1.22,4.145,2.171,7.354,2.396c3.208,0.225,6.033-0.339,7.616-1.347 c-1.427-1.22-4.145-2.171-7.354-2.396C220.61,238.772,217.787,239.336,216.202,240.344z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M231.173,241.393c1.22-1.427,2.171-4.145,2.396-7.354c0.225-3.209-0.339-6.033-1.347-7.616 c-1.22,1.427-2.171,4.145-2.396,7.354C229.601,236.985,230.164,239.809,231.173,241.393z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M211.896,228.095c1.139,1.493,3.595,2.994,6.686,3.889s5.969,0.938,7.729,0.286 c-1.139-1.493-3.595-2.994-6.686-3.889C216.535,227.486,213.656,227.443,211.896,228.095z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M226.31,232.269c1.493-1.139,2.994-3.597,3.889-6.686s0.938-5.969,0.286-7.729 c-1.493,1.139-2.994,3.596-3.889,6.686C225.701,227.629,225.658,230.51,226.31,232.269z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M210.074,213.794c0.717,1.735,2.705,3.818,5.461,5.478s5.527,2.441,7.396,2.263 c-0.717-1.735-2.705-3.818-5.461-5.478C214.715,214.399,211.943,213.616,210.074,213.794z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M222.93,221.535c1.735-0.717,3.818-2.705,5.478-5.461s2.441-5.527,2.263-7.396 c-1.735,0.717-3.818,2.705-5.478,5.461C223.534,216.895,222.753,219.666,222.93,221.535z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M211.801,200.291c0.338,1.847,1.844,4.3,4.192,6.501c2.346,2.2,4.892,3.546,6.757,3.763 c-0.338-1.847-1.844-4.3-4.192-6.501C216.212,201.855,213.666,200.509,211.801,200.291z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M222.749,210.555c1.847-0.338,4.3-1.844,6.501-4.192c2.2-2.346,3.546-4.892,3.763-6.757 c-1.847,0.338-4.3,1.844-6.501,4.192C224.313,206.145,222.967,208.691,222.749,210.555z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M218.584,185.68c-0.386,1.838,0.08,4.679,1.42,7.603s3.187,5.133,4.831,6.04 c0.386-1.838-0.08-4.679-1.42-7.603C222.075,188.796,220.228,186.588,218.584,185.68z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M224.835,199.324c1.838,0.386,4.679-0.08,7.603-1.42s5.133-3.187,6.04-4.831 c-1.838-0.386-4.679,0.08-7.603,1.42C227.952,195.833,225.742,197.68,224.835,199.324z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M226.696,174.86c-0.866,1.666-1.179,4.528-0.675,7.705s1.69,5.8,3.03,7.116 c0.866-1.666,1.179-4.528,0.675-7.705C229.222,178.801,228.036,176.176,226.696,174.86z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M229.051,189.682c1.666,0.866,4.528,1.181,7.705,0.675c3.177-0.504,5.8-1.69,7.116-3.03 c-1.666-0.866-4.528-1.179-7.705-0.675C232.99,187.156,230.367,188.342,229.051,189.682z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M234.651,167.33c-1.102,1.52-1.835,4.305-1.803,7.521c0.032,3.216,0.818,5.986,1.949,7.485 c1.101-1.52,1.835-4.304,1.803-7.521S235.782,168.828,234.651,167.33z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M234.797,182.336c1.52,1.102,4.305,1.835,7.521,1.803c3.217-0.031,5.986-0.818,7.485-1.949 c-1.52-1.101-4.305-1.834-7.521-1.803C239.065,180.418,236.295,181.205,234.797,182.336z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M238.657,178.391c1.872,0.152,4.631-0.67,7.363-2.367c2.732-1.698,4.691-3.809,5.383-5.554 c-1.872-0.152-4.631,0.67-7.363,2.367C241.308,174.535,239.35,176.645,238.657,178.391z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M269.715,262.408v-2.3c25.358,0,45.99-20.631,45.99-45.99c0-15.753-7.929-30.24-21.211-38.75 l1.24-1.936c13.945,8.935,22.271,24.145,22.271,40.686C318.005,240.745,296.342,262.408,269.715,262.408z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M297.352,265.422c-1.84,0.375-4.678-0.11-7.594-1.469s-5.113-3.22-6.009-4.87 c1.84-0.375,4.678,0.111,7.594,1.469C294.259,261.911,296.455,263.772,297.352,265.422z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M283.749,259.083c-0.375-1.84,0.11-4.678,1.469-7.594s3.22-5.113,4.87-6.009 c0.375,1.84-0.111,4.678-1.469,7.594C287.26,255.99,285.399,258.188,283.749,259.083z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M306.973,259.516c-1.765,0.64-4.644,0.578-7.727-0.338c-3.084-0.916-5.53-2.434-6.659-3.934 c1.765-0.64,4.643-0.578,7.727,0.338C303.397,256.497,305.844,258.016,306.973,259.516z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M292.587,255.244c-0.641-1.765-0.578-4.644,0.338-7.727c0.916-3.084,2.434-5.53,3.934-6.659 c0.64,1.765,0.578,4.644-0.338,7.727C295.605,251.669,294.087,254.115,292.587,255.244z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M315.872,251.464c-1.62,0.947-4.465,1.402-7.663,1.056c-3.198-0.347-5.877-1.401-7.257-2.674 c1.62-0.947,4.465-1.402,7.662-1.056C311.812,249.137,314.492,250.191,315.872,251.464z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M300.953,249.846c-0.947-1.62-1.402-4.465-1.055-7.662s1.401-5.877,2.674-7.257 c0.947,1.62,1.402,4.465,1.056,7.662C303.28,245.785,302.225,248.465,300.953,249.846z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M323.228,240.344c-1.427,1.22-4.145,2.171-7.354,2.396c-3.208,0.225-6.033-0.339-7.616-1.347 c1.427-1.22,4.145-2.171,7.354-2.396S321.645,239.336,323.228,240.344z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M308.258,241.393c-1.22-1.427-2.171-4.145-2.396-7.354c-0.225-3.208,0.339-6.033,1.347-7.616 c1.22,1.427,2.171,4.145,2.396,7.354C309.829,236.985,309.266,239.809,308.258,241.393z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M327.535,228.095c-1.139,1.493-3.595,2.994-6.686,3.889c-3.089,0.895-5.969,0.938-7.729,0.286 c1.139-1.493,3.597-2.994,6.686-3.889C322.895,227.486,325.775,227.443,327.535,228.095z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M313.12,232.269c-1.493-1.139-2.994-3.597-3.889-6.686c-0.895-3.089-0.938-5.969-0.286-7.729 c1.493,1.139,2.994,3.596,3.889,6.686C313.729,227.629,313.773,230.51,313.12,232.269z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M329.357,213.794c-0.717,1.735-2.705,3.818-5.461,5.478s-5.527,2.441-7.396,2.263 c0.717-1.735,2.705-3.818,5.461-5.478C324.717,214.399,327.488,213.616,329.357,213.794z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M316.5,221.535c-1.735-0.717-3.818-2.705-5.478-5.461s-2.441-5.527-2.263-7.396 c1.735,0.717,3.818,2.705,5.478,5.461C315.896,216.895,316.679,219.666,316.5,221.535z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M327.63,200.291c-0.338,1.847-1.844,4.3-4.192,6.501c-2.346,2.2-4.892,3.546-6.757,3.763 c0.338-1.847,1.844-4.3,4.192-6.501C323.22,201.855,325.764,200.509,327.63,200.291z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M316.682,210.555c-1.847-0.338-4.3-1.844-6.501-4.192c-2.2-2.346-3.546-4.892-3.763-6.757 c1.847,0.338,4.3,1.844,6.501,4.192C315.118,206.145,316.463,208.691,316.682,210.555z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M320.846,185.68c0.386,1.838-0.08,4.679-1.42,7.603c-1.34,2.924-3.187,5.133-4.831,6.04 c-0.386-1.838,0.08-4.679,1.42-7.603C317.355,188.797,319.202,186.588,320.846,185.68z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M314.595,199.324c-1.838,0.386-4.679-0.08-7.603-1.42s-5.134-3.187-6.04-4.831 c1.838-0.386,4.679,0.08,7.603,1.42C311.478,195.833,313.688,197.68,314.595,199.324z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M312.734,174.86c0.866,1.666,1.18,4.528,0.675,7.705c-0.504,3.177-1.69,5.8-3.03,7.116 c-0.866-1.666-1.18-4.528-0.675-7.705C310.209,178.801,311.394,176.176,312.734,174.86z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M310.38,189.682c-1.666,0.866-4.528,1.181-7.705,0.675c-3.177-0.504-5.8-1.69-7.116-3.03 c1.666-0.866,4.528-1.179,7.705-0.675C306.44,187.156,309.065,188.342,310.38,189.682z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M304.779,167.33c1.101,1.52,1.835,4.305,1.803,7.521s-0.818,5.986-1.949,7.485 c-1.102-1.52-1.835-4.304-1.803-7.521C302.862,171.598,303.648,168.828,304.779,167.33z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M304.634,182.336c-1.52,1.102-4.305,1.835-7.521,1.803c-3.217-0.031-5.986-0.818-7.485-1.949 c1.52-1.101,4.305-1.834,7.521-1.803C300.365,180.418,303.135,181.205,304.634,182.336z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M300.773,178.391c-1.872,0.152-4.631-0.67-7.363-2.367c-2.732-1.698-4.691-3.809-5.383-5.554 c1.872-0.152,4.632,0.67,7.363,2.367C298.122,174.535,300.08,176.645,300.773,178.391z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#966446"
    },
    d: "M243.354,251.713l-8.37,8.37l-4.127-8.255l12.383-12.383l4.127,4.127l-1.192,3.576 C245.601,248.87,244.634,250.432,243.354,251.713z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B9B9B9"
    },
    d: "M288.641,189.916l-45.402,45.402c-1.139,1.139-1.139,2.988,0,4.127l2.064,2.064l8.255-8.255 l33.02-37.148l4.127-4.127L288.641,189.916z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#966446"
    },
    d: "M254.412,228.272c-0.548,0.548-0.855,1.29-0.855,2.064v2.918l33.02-37.148L254.412,228.272z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A0A0A0"
    },
    points: "290.704,191.98 288.641,189.916 286.577,191.98 288.641,194.043 290.704,196.107  313.406,169.278 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#966446"
    },
    d: "M298.376,251.713l8.37,8.37l4.127-8.255l-12.383-12.383l-4.127,4.127l1.192,3.576 C296.129,248.87,297.096,250.432,298.376,251.713z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B9B9B9"
    },
    d: "M253.089,189.916l45.402,45.402c1.139,1.139,1.139,2.988,0,4.127l-2.064,2.064l-8.255-8.255 l-33.02-37.148l-4.127-4.127L253.089,189.916z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#966446"
    },
    d: "M287.318,228.272c0.548,0.548,0.855,1.29,0.855,2.064v2.918l-33.02-37.148L287.318,228.272z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A0A0A0"
    },
    points: "251.026,191.98 253.089,189.916 255.153,191.98 253.089,194.043 251.026,196.107  228.324,169.278 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B9B9B9"
    },
    d: "M253.925,249.995l2.051,1.871c7.482-8.204,20.577-22.559,41.334-41.197 C297.31,210.669,280.113,221.285,253.925,249.995z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M248.122,258.417L248.122,258.417c-0.736-0.671-0.788-1.813-0.117-2.549l4.396-4.819 c0.672-0.736,1.813-0.789,2.549-0.117l0,0c0.736,0.671,0.788,1.813,0.117,2.549l-4.396,4.819 C249.999,259.036,248.858,259.089,248.122,258.417z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC855"
    },
    d: "M252.259,248.477l-1.191,0.53c-1.059,0.527-3.846,2.104-4.326,4.349 c-0.229,1.065,0.094,2.101,0.92,3.082c0.078-0.203,0.186-0.399,0.342-0.569l0.553-0.607c-0.375-0.543-0.573-1.077-0.459-1.612 c0.301-1.405,2.175-2.659,3.352-3.28l5.266,4.803l1.309-1.436L252.259,248.477z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B9B9B9"
    },
    d: "M287.785,252.267l-2.051,1.871c-7.482-8.204-20.577-22.559-41.334-41.197 C244.4,212.941,261.597,223.555,287.785,252.267z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M293.588,260.688L293.588,260.688c0.736-0.672,0.789-1.813,0.117-2.549l-4.396-4.819 c-0.672-0.736-1.813-0.788-2.549-0.117l0,0c-0.736,0.672-0.788,1.813-0.117,2.549l4.396,4.819 C291.71,261.307,292.851,261.36,293.588,260.688z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC855"
    },
    d: "M289.45,250.749l1.191,0.531c1.059,0.528,3.845,2.104,4.326,4.349 c0.229,1.065-0.094,2.099-0.92,3.082c-0.078-0.203-0.186-0.399-0.342-0.57l-0.553-0.607c0.375-0.543,0.573-1.076,0.459-1.612 c-0.301-1.405-2.175-2.659-3.352-3.28l-5.266,4.803l-1.309-1.436L289.45,250.749z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#69B469"
    },
    d: "M271.761,176.316c0.161-0.399,0.254-0.832,0.254-1.288c0-1.904-1.545-3.449-3.449-3.449 c-1.905,0-3.449,1.545-3.449,3.449c0,1.135,0.556,2.134,1.402,2.763c-1.246,10.018,8.63,10.783,12.394,12.184 c5.711,2.125,12.874,6.424,12.424,18.44c-0.438,11.681-7.825,22.951-7.825,22.951l6.132-8.336 c-2.243,9.483-7.478,21.563-19.929,35.929c0,0,8.513-8.328,15.617-19.067c-5.227,12.297-11.018,23.666-11.018,23.666 s10.251-13.318,18.54-36.361C302.902,199.26,281.765,182.476,271.761,176.316z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 253.62,
    y: 217.56,
    style: {
      fill: "#F4E08F"
    },
    width: 9.199,
    height: 4.599
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ECD077"
    },
    d: "M258.162,221.44c0.476,3.108-2.163,5.747-5.27,5.27c-1.937-0.296-3.519-1.879-3.816-3.816 c-0.476-3.108,2.163-5.747,5.27-5.27C256.283,217.92,257.865,219.503,258.162,221.44z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ECD077"
    },
    d: "M258.162,191.546c0.476,3.108-2.163,5.747-5.27,5.27c-1.937-0.296-3.519-1.879-3.816-3.816 c-0.476-3.108,2.163-5.747,5.27-5.27C256.283,188.027,257.865,189.61,258.162,191.546z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCF0A8"
    },
    d: "M281.212,196.873c2.54,0,4.599-2.059,4.599-4.599s-2.059-4.599-4.599-4.599h-27.594 c2.54,0,4.599,2.059,4.599,4.599s-2.059,4.599-4.599,4.599c-2.539,0-4.599-2.059-4.599-4.599c0,7.719,6.461,17.054,8.543,25.295 c0,0,0.654,2.059,0.654,4.599s-2.059,4.599-4.599,4.599h27.594c2.54,0,4.599-2.059,4.599-4.599c0-7.719-6.461-17.054-8.543-25.295 H281.212z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F4E08F"
    },
    d: "M258.218,192.273c0,2.539-2.059,4.599-4.599,4.599h27.594c2.54,0,4.599-2.059,4.599-4.599H258.218z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F4E08F"
    },
    d: "M258.218,222.167c0,2.539-2.059,4.599-4.599,4.599h27.594c2.54,0,4.599-2.059,4.599-4.599H258.218z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2E3033"
    },
    d: "M19.122,488.1L19.122,488.1C8.561,488.1,0,479.539,0,468.979V42.864C0,32.39,8.491,23.9,18.965,23.9 h0.157c10.561,0,19.122,8.561,19.122,19.122V468.98C38.244,479.539,29.683,488.1,19.122,488.1z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGt);
export default __webpack_public_path__ + "static/media/gt.be691569bdf2b1ab5e9d83397968cd66.svg";
export { ForwardRef as ReactComponent };